import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallbackPage() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/signin", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);

    api.post("/auth/google/session", { session_id })
      .then((r) => {
        setUser(r.data.user);
        // Remove fragment then go to account
        window.history.replaceState(null, "", window.location.pathname);
        nav("/account", { replace: true });
      })
      .catch(() => {
        nav("/signin?error=google", { replace: true });
      });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-display text-2xl text-[color:var(--color-primary)] mb-2">Signing you in…</div>
        <div className="text-sm text-gray-500">Please wait.</div>
      </div>
    </div>
  );
}
